import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp, ExternalLink, FileText } from "lucide-react";
import { useState } from "react";

interface InspectionCardProps {
  cve_codigo: string;
  vis_token: string | null;
  cls_codigo: string | null;
}

export function InspectionCard({
  cve_codigo,
  vis_token,
  cls_codigo,
}: InspectionCardProps) {
  void cls_codigo;
  const [isExpanded, setIsExpanded] = useState(false);

  const isInspectionLikelyAvailable = vis_token !== null;

  const url = `${import.meta.env.VITE_API_URL}/visualizar_vistoria_nova_pdf.php?cve_codigo=${cve_codigo}&token=${vis_token}`;

  const handleOpenInspection = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-semibold text-n-green">Vistoria Digital:</h3>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 rounded-lg bg-gray-50 border border-gray-200">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-n-green/10 flex items-center justify-center">
              <FileText className="w-5 h-5 text-n-green" />
            </div>
            <div className="flex flex-col">
              <p className="text-sm font-semibold text-n-text-green">
                Relatório de Vistoria
              </p>
              <p className="text-sm text-gray-600">
                {isInspectionLikelyAvailable
                  ? "Acesse o documento completo da vistoria do seu veículo."
                  : "Acesse o documento completo da vistoria do seu veículo, é possível que ainda não esteja disponível."}
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              onClick={toggleExpand}
              variant="green"
              size="sm"
              className="w-full sm:w-auto"
            >
              {isExpanded ? (
                <>
                  Fechar
                  <ChevronUp className="w-4 h-4 ml-2" />
                </>
              ) : (
                <>
                  Abrir aqui
                  <ChevronDown className="w-4 h-4 ml-2" />
                </>
              )}
            </Button>
            <Button
              onClick={handleOpenInspection}
              variant="default"
              size="sm"
              className="w-full sm:w-auto"
            >
              Nova aba
              <ExternalLink className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>

        {isExpanded && (
          <div className="w-full rounded-lg overflow-hidden border border-gray-200 shadow-sm">
            <iframe
              src={url}
              className="w-full h-[600px] md:h-[800px]"
              title="Vistoria Digital do Veículo"
            />
          </div>
        )}
      </div>
    </div>
  );
}
